const asArray = (value) => {
	if (value == null) return [];
	return Array.isArray(value) ? value : [value];
};

export function prepareGraphqlFilters(filters) {
	if (!filters) return {};

	const cloned = structuredClone(filters);

	for (const condition of Object.values(cloned)) {
		if (!condition || typeof condition !== 'object') continue;

		if (typeof condition.rangeDate === 'string') {
			const [min, max] = condition.rangeDate.split('~');
			condition.rangeDate = { min, max };
		}

		if (typeof condition.range === 'string') {
			const [min, max] = condition.range.split('~');
			condition.range = [
				{
					min: Number(min),
					max: Number(max),
				},
			];
		}
	}

	return cloned;
}

export function pickFilters(filters, allowedKeys) {
	return Object.fromEntries(
		Object.entries(filters).filter(([key]) => allowedKeys.includes(key)),
	);
}

export function intersectIdLists(selected, allowed) {
	const selectedIds = asArray(selected).map(Number);
	const allowedIds = asArray(allowed).map(Number);

	if (!allowedIds.length) return selectedIds;

	return selectedIds.filter((id) => allowedIds.includes(id));
}
